import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { Shape as PinShape } from 'next/entities/experiences';
import { ConditionText } from './styled';

export const PinCondition = ({
  operator,
  negated,
  pins,
  experienceStep: experienceStepId,
}) => {
  const negative = negated || operator === '!=';
  const pinName = useMemo(() => {
    return Object.values(pins ?? {})
      .flatMap(({ steps }) => steps)
      .find(({ id }) => id === experienceStepId)?.name;
  }, [experienceStepId, pins]);

  return (
    <ConditionText>
      Pin {pinName || experienceStepId} has {negative ? 'not' : ''} been
      interacted with.
    </ConditionText>
  );
};

PinCondition.propTypes = {
  experienceStep: PropTypes.string,
  operator: PropTypes.string.isRequired,
  pins: PropTypes.objectOf(PinShape),
  negated: PropTypes.bool,
};

export default PinCondition;
